import { useQuery } from 'react-query';
import { GetEntities } from '../../../interfaces/shared.interface';
import { apiRQ } from '../../api';

export interface ProductOrderInList {
  id: string;
  quantity: number;
  price: number;
  finalCost: number;
  createdAt: string;
  invoiceId: string;
  invoice?: { currency: string };
}

const getProductOrders = async (productId: string, page: number): Promise<GetEntities<ProductOrderInList>> => {
  const resp = await apiRQ.get<GetEntities<ProductOrderInList>>(`/products/${productId}/orders`, { params: { page } });
  return resp.data;
};

export const useProductOrders = (productId: string, page: number) => {
  return useQuery<GetEntities<ProductOrderInList>, Error>(
    ['useProductOrders', productId, page],
    () => getProductOrders(productId, page),
    { cacheTime: 10_000, staleTime: 10_000, retry: 3 },
  );
};
